import React, { useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";
import { Card, Btn } from "./UI";
import { toast } from "sonner";
import { ShieldCheck, Check, X } from "lucide-react";

export const ManualReviewsCard = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/political-os/verification/manual-reviews")
    .then(r => setRows(r.data.requests)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const decide = async (eid, approve) => {
    try {
      await api.post(`/political-os/entities/${eid}/verification/manual-review/${approve ? "approve" : "reject"}`);
      toast.success(approve ? "Approved — campaign earned the final +10 verification points" : "Request rejected");
      load();
    } catch (e) { toast.error(errMsg(e, "Could not record the decision")); }
  };

  if (!rows?.length) return null;
  return (
    <Card padded={false} data-testid="manual-reviews-card">
      <div className="px-5 py-4 border-b border-white/10 flex items-center gap-2">
        <ShieldCheck className="w-4 h-4 text-amber-300" />
        <h3 className="font-display font-bold">Manual verification reviews</h3>
        <span className="text-xs px-2 py-0.5 rounded-full bg-amber-400/15 text-amber-200 border border-amber-400/25" data-testid="manual-reviews-count">
          {rows.length} pending
        </span>
      </div>
      <div className="divide-y divide-white/5">
        {rows.map(r => (
          <div key={r.entity_id} className="px-5 py-3 flex flex-wrap items-center gap-3" data-testid={`review-row-${r.entity_id}`}>
            <div className="flex-1 min-w-[200px]">
              <div className="text-sm text-white font-medium">{r.name}</div>
              <div className="text-xs text-slate-500">
                {[r.office, r.state].filter(Boolean).join(" · ")} · score {r.score}/100
                {r.website ? <> · <a href={r.website} target="_blank" rel="noreferrer" className="text-cyan-300 hover:underline">{r.website.replace(/^https?:\/\//, "")}</a></> : null}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Btn variant="secondary" className="!px-3 !py-1.5 text-xs" onClick={() => decide(r.entity_id, true)} data-testid={`approve-review-${r.entity_id}`}>
                <Check className="w-3.5 h-3.5" /> Approve
              </Btn>
              <button onClick={() => decide(r.entity_id, false)} data-testid={`reject-review-${r.entity_id}`}
                className="text-slate-500 hover:text-rose-300 p-1.5" title="Reject">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
